"use client";

import posthog from "posthog-js";
import { useCallback } from "react";

import { axios } from "../axios";
import { API_ENDPOINTS } from "../constants/api-endpoints";

const signoutCurrentUser = async () => {
  try {
    await axios.post(API_ENDPOINTS.AUTH.SIGN_OUT);
  } catch (error) {
    console.error("Failed to sign out", error);
  }
};

export const useSignout = () => {
  const signout = useCallback(async () => {
    posthog.reset();
    sessionStorage.clear();
    await signoutCurrentUser();
    window.location.href = "/";
  }, []);

  return { signout };
};
